import React from "react";

function Icon({ className }) {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <circle cx="25" cy="25" r="24" fill="white" fillOpacity="0.5" />
        <circle cx="25" cy="25" r="24.5" stroke="white" />
      </g>
      <path
        d="M13.5 20.1196V14.6293C17.1864 12.6344 20.8777 13.6642 24.8011 14.7992C24.8449 14.8118 24.8887 14.8245 24.9326 14.8372C28.6417 15.9106 32.5656 17.0461 36.5 15.1652V20.6555C32.8136 22.6504 29.1223 21.6206 25.1989 20.4857C25.1551 20.473 25.1113 20.4603 25.0674 20.4476C21.3583 19.3742 17.4344 18.2387 13.5 20.1196ZM36.6883 20.5509L36.6864 20.5521L36.6883 20.5509Z"
        stroke="#111111"
      />
      <path
        d="M13.5 28.7168V23.2265C17.1864 21.2316 20.8777 22.2614 24.8011 23.3963C24.8449 23.409 24.8887 23.4217 24.9325 23.4344C28.6417 24.5078 32.5655 25.6433 36.5 23.7624V29.2527C32.8136 31.2476 29.1223 30.2178 25.1989 29.0829C25.1551 29.0702 25.1113 29.0575 25.0674 29.0448C21.3583 27.9714 17.4344 26.8359 13.5 28.7168ZM36.6881 29.1483L36.6864 29.1493L36.6881 29.1483Z"
        stroke="#111111"
      />
      <path
        d="M18.4929 30.7118C18.4706 30.7111 18.4481 30.7105 18.4253 30.71C17.7541 30.6944 16.8598 30.7264 15.9493 30.9113L18.4929 30.7118ZM18.4929 30.7118L13.5 35.9391V31.7982C13.8477 31.5896 14.6578 31.1739 15.9492 30.9113L18.4929 30.7118Z"
        stroke="#111111"
      />
      <defs>
        <filter
          id="filter0_b"
          x="-10"
          y="-10"
          width="70"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;
